import React from "react";
import { MenaVstupy } from "../vstupneKomponenty";

const PredcasneSplatenieVstupKarta = React.forwardRef(function PredcasneSplatenieVstupKarta({
  ppOpen,
  ppRezim,
  setPpRezim,
  ppJednoraz,
  setPpJednoraz,
  ppMesacne,
  setPpMesacne,
  ppRocne,
  setPpRocne,
  ppStart,
  setPpStart,
  ppOpakovania,
  setPpOpakovania,
  celkovoMesiacovPP,
  startMoznost,
  repeatValueEfekt,
  opakovaniaMoznost,
  ppClamped,
}, ref) {
  if (!ppOpen) return null;

  return (
              <div ref={ref} className="card-section card-section--pp-vstup">
                <div className="prepay-head">
                  <h2>Predčasné splatenie</h2>
                </div>
    
                <div className="prepay-mode-row">
                  <span className="prepay-mode-label"><strong>Vyber možnosť:</strong></span>
    
                  <div className="prepay-toggles">
                  {/* STEPper prepínač režimu PS */}
                  <div className={`pp-stepper ${ppOpen ? "" : "is-disabled"}`}>
                    <button
                      type="button"
                      className={`pp-step ${ppRezim === "skratenie" ? "is-active" : ""}`}
                      onClick={() => setPpRezim("skratenie")}
                      disabled={!ppOpen}
                    >
                      Skrátenie splatnosti
                    </button>
                    <button
                      type="button"
                      className={`pp-step ${ppRezim === "znizenie" ? "is-active" : ""}`}
                      onClick={() => setPpRezim("znizenie")}
                      disabled={!ppOpen}
                    >
                      Zníženie splátky
                    </button>
                  </div>
                </div>
              </div>
    
                  
                  <div className="form-group form-group--cols3">
                    <div className="form form--m">
                      <MenaVstupy
                        value={ppJednoraz}
                        onChange={setPpJednoraz}
                        maxDigits={7}
                        suffix="€"
                        placeholder="0"
                      />
                      <label className="form_label">Jednorázovo</label>
                    </div>
    
                    <div className="form form--m">
                      <MenaVstupy
                        value={ppMesacne}
                        onChange={setPpMesacne}
                        maxDigits={7}
                        suffix="€"
                        placeholder="0"
                      />
                      <label className="form_label">Pravidelne mesačne</label>
                    </div>
    
                    <div className="form form--m">
                      <MenaVstupy
                        value={ppRocne}
                        onChange={setPpRocne}
                        maxDigits={7}
                        suffix="€"
                        placeholder="0"
                      />
                      <label className="form_label">Pravidelne ročne</label>
                    </div> 
                  </div>
    
                      <div className="form-group form-group--cols2 pp-riadok2">
                        <div className="form form--m">
                          <select
                            className="form_select"
                            value={ppStart + 1}
                            onChange={(e) => {
                              const idx = Math.max(0, Math.min(celkovoMesiacovPP - 1, (Number(e.target.value) || 1) - 1));
                              setPpStart(idx);
                            }}
                          >
                            {startMoznost.map((m) => (
                              <option key={m} value={m}>{m}</option>
                            ))}
                          </select>
                          <label className="form_label">Začiatok (mesiac)</label>
                        </div>
    
                        <div className="form form--m">
                          <select
                            className="form_select"
                            value={ppOpakovania || repeatValueEfekt} 
                            onChange={(e) => setPpOpakovania(Number(e.target.value) || 0)}
                            disabled={!opakovaniaMoznost.length}
                          >
                            {opakovaniaMoznost.map((k) => (
                              <option key={k} value={k}>{k}</option>
                            ))}
                          </select>
                          <label className="form_label">Počet opakovaní (ročne)</label>
                        </div>
                        {ppOpen && ppClamped?.events?.length === 0 && (
                          <div className="pp-hint error">Zadaj aspoň jednu vstupnú hodnotu</div>
                        )}
                      </div>
                      
                    
                  </div>
                    
  );
});

export default PredcasneSplatenieVstupKarta;